import { message } from 'antd';

import { select, call, put, takeEvery, takeLatest, all, fork } from 'redux-saga/effects'
import { getDashboardCounts, getDashboardModalityCountsAPI } from '../../services/dashboard-service';

import { FETCH_DASHBOARD, FETCH_DASHBOARD_ERROR, FETCH_DASHBOARD_MODALITY_COUNTS, FETCH_DASHBOARD_MODALITY_COUNTS_ERROR, FETCH_DASHBOARD_MODALITY_COUNTS_SUCCESS, FETCH_DASHBOARD_START, FETCH_DASHBOARD_SUCCESS } from '../actions/dashboardActions';

const getAuthUserState = (state) => state.auth.authUser;

function* fetchDashboard({ }) {

    try {
        yield put({ type: FETCH_DASHBOARD_START })
        const authUser = yield select(getAuthUserState);
        if (authUser) {
            const role = authUser.role.replace("ROLE_", "");
            const response = yield getDashboardCounts(role);
            if (response.success) {
                yield put({ type: FETCH_DASHBOARD_SUCCESS, dashboard: response.data })
            } else {
                yield put({ type: FETCH_DASHBOARD_ERROR, message: 'Failed to fetch dashboard info!' })
            }
        }
    } catch (error) {
        yield put({ type: FETCH_DASHBOARD_ERROR, error })
        message.error('Failed to fetch dashboard info!');
    }

}

function* fetchDashboardModalityCounts({ payload }) {
    try {
        const response = yield call(getDashboardModalityCountsAPI, payload);
        if (response.success) {
            yield put({ type: FETCH_DASHBOARD_MODALITY_COUNTS_SUCCESS, modalityDahsboard: response.data })
        } else {
            yield put({ type: FETCH_DASHBOARD_MODALITY_COUNTS_ERROR, message: 'Failed to fetch dashboard info!' })
        }
    } catch (error) {
        yield put({ type: FETCH_DASHBOARD_ERROR, error })
        message.error('Failed to fetch modality info!');
    }
}

function* dashboardWatcher() {
    yield takeEvery(FETCH_DASHBOARD, fetchDashboard)
    yield takeLatest(FETCH_DASHBOARD_MODALITY_COUNTS, fetchDashboardModalityCounts)
}

export default function* rootSaga() {
    yield all([
        dashboardWatcher(),
    ]);
}